(function () {
  'use strict';

  function initPremium(instance) {
    var slider = instance.slider;
    if (!slider || instance._sl_init) return;
    instance._sl_init = true;

    var mode = slider.dataset.transition || 'slide';
    var speed = parseInt(slider.dataset.transitionSpeed || '700', 10);
    var imageMotion = slider.dataset.imageMotion === 'true';

    instance._sl_mode = mode;
    instance._sl_speed = speed;
    instance._sl_imageMotion = imageMotion || mode === 'fade_zoom';
    instance._sl_index = 0;
    instance._sl_exitTimeout = null;

    if (mode === 'slide') return;

    /* ── CSS setup ─── */
    var cssMode = mode === 'fade_zoom' ? 'fade-zoom' : 'fade';
    slider.classList.add('slideshow--premium', 'slideshow--' + cssMode);
    slider.style.setProperty('--sl-duration', speed + 'ms');
    if (instance._sl_imageMotion) slider.classList.add('slideshow--image-motion');

    /* ── Mark initial slide states ─── */
    instance.sliderItemsToShow.forEach(function (s, i) {
      if (i === 0) {
        s.classList.add('slideshow__slide--active');
      } else {
        s.setAttribute('aria-hidden', 'true');
        s.setAttribute('tabindex', '-1');
        s.querySelectorAll('a, button').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
      }
    });

    /* ── Core transition — no blocking lock so every click responds ─── */
    instance._sl_goTo = function (idx) {
      var slides = instance.sliderItemsToShow;
      var n = slides.length;
      idx = ((idx % n) + n) % n;
      if (idx === instance._sl_index) return;

      var prev = slides[instance._sl_index];
      var next = slides[idx];

      /* Cancel any pending exiting-class cleanup from a previous transition */
      if (instance._sl_exitTimeout) clearTimeout(instance._sl_exitTimeout);

      /* Reset image motion animation on incoming slide */
      if (instance._sl_imageMotion) {
        var img = next.querySelector('.banner__media img');
        if (img) { img.style.animation = 'none'; void img.offsetHeight; img.style.animation = ''; }
      }

      /* Clear stale exiting states from all slides */
      slides.forEach(function (s) { s.classList.remove('slideshow__slide--exiting'); });

      prev.classList.remove('slideshow__slide--active');
      prev.classList.add('slideshow__slide--exiting');
      next.classList.add('slideshow__slide--active');

      instance._sl_index = idx;
      instance.currentPage = idx + 1;

      /* Sync dot buttons */
      instance.querySelectorAll('.slider-counter__link').forEach(function (btn, i) {
        var on = i === idx;
        btn.classList.toggle('slider-counter__link--active', on);
        on ? btn.setAttribute('aria-current', 'true') : btn.removeAttribute('aria-current');
      });

      /* Sync counter */
      if (instance.currentPageElement) instance.currentPageElement.textContent = idx + 1;

      /* Sync accessibility */
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (a) {
          on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1');
        });
        on ? s.removeAttribute('tabindex') : s.setAttribute('tabindex', '-1');
      });

      /* Remove exiting class after animation completes */
      instance._sl_exitTimeout = setTimeout(function () {
        prev.classList.remove('slideshow__slide--exiting');
      }, speed + 60);
    };

    /* ── Wire buttons directly (Dawn binds listeners at construct time; prototype patches are bypassed) ─── */

    if (instance.prevButton) {
      instance.prevButton.addEventListener('click', function () {
        var n = instance.sliderItemsToShow.length;
        instance._sl_goTo((instance._sl_index - 1 + n) % n);
      });
    }

    if (instance.nextButton) {
      instance.nextButton.addEventListener('click', function () {
        instance._sl_goTo((instance._sl_index + 1) % instance.sliderItemsToShow.length);
      });
    }

    instance.sliderControlLinksArray.forEach(function (link, i) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        instance._sl_goTo(i);
      });
    });

    /* ── Override instance.play/pause so autoplay uses _sl_goTo ─── */
    instance.play = function () {
      clearTimeout(instance._sl_resumeTimeout);
      instance.slider.setAttribute('aria-live', 'off');
      clearInterval(instance.autoplay);
      instance.autoplay = setInterval(function () {
        instance._sl_goTo((instance._sl_index + 1) % instance.sliderItemsToShow.length);
      }, instance.autoplaySpeed);
    };

    instance.pause = function () {
      instance.slider.setAttribute('aria-live', 'polite');
      clearInterval(instance.autoplay);
      /*
       * On mobile, focusout/mouseleave don't fire reliably after a tap,
       * so autoplay would stay paused forever. Schedule an auto-resume
       * after 3s of inactivity unless the user explicitly pressed pause.
       */
      clearTimeout(instance._sl_resumeTimeout);
      if (instance.autoplaySpeed) {
        instance._sl_resumeTimeout = setTimeout(function () {
          if (instance.autoplayButtonIsSetToPlay !== false) {
            instance.play();
          }
        }, 3000);
      }
    };

    /* Restart autoplay with fade logic if it was already running */
    if (instance.autoplay) {
      instance.play();
    }
  }

  customElements.whenDefined('slideshow-component').then(function () {
    var SC = customElements.get('slideshow-component');
    if (SC._sl_patched) return;
    SC._sl_patched = true;

    /* setSlidePosition: native for slide mode, no-op for fade (prevents scroll artifacts) */
    var _origSetPos = SC.prototype.setSlidePosition;
    SC.prototype.setSlidePosition = function (position) {
      if (!this._sl_mode || this._sl_mode === 'slide') return _origSetPos.call(this, position);
    };

    /* update: skip in fade mode */
    var _origUpdate = SC.prototype.update;
    SC.prototype.update = function () {
      if (this._sl_mode && this._sl_mode !== 'slide') return;
      _origUpdate.call(this);
    };

    /* setSlideVisibility: skip in fade mode */
    var _origViz = SC.prototype.setSlideVisibility;
    SC.prototype.setSlideVisibility = function (event) {
      if (this._sl_mode && this._sl_mode !== 'slide') return;
      _origViz.call(this, event);
    };

    /* Init all existing instances */
    document.querySelectorAll('slideshow-component').forEach(function (el) {
      initPremium(el);
    });

    /* Watch for new instances added by theme editor */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.tagName === 'SLIDESHOW-COMPONENT') {
            requestAnimationFrame(function () { initPremium(node); });
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
